module.exports = __webpack_public_path__ + "assets/img/collate-page-bg.427a3216.png";